import {font_s_lg, font_s_xxl, font_s_md,colors} from '@xpertdox_js/xdstyle';

export default {
  container: {

  },
  emergencyBox: {
    ...font_s_md,
    paddingLeft: '1.2rem',
    color: colors.darkGray,
  },
  emergencyList: {
    marginBottom: '2.4rem',
    listStyle: 'none',
    paddingLeft: '1rem'
  },
  emergencyText: {
    ...font_s_lg,
    marginBottom: 0,
  },
  admins: {
    container: {
      display: 'flex',
      flexDirection: 'row'
    },
    admin: {
      background: 'rgb(255, 255, 255) none repeat scroll 0% 0%',
      borderRadius: 3,
      boxShadow: 'rgba(0, 0, 0, 0.56) 0px 3px 8px -5px',
      padding: 12,
      margin:'10px 5px 10px 0px',
      fontSize: '1.4rem'
    },
    tag: {
      margin: 2
    }
  },
  formDescription: {
    marginTop: '10px',
    maxWidth: '865px',
    padding: '10px',
    borderBottom: '1px solid rgba(0,0,0,0.15)'
  },
  title: {
    ...font_s_xxl,
    marginTop: 0,
  },
  formWrap: {
    maxWidth: '865px',
    padding: '10px',
  },
  description: {
    ...font_s_lg,
    maxWidth: '765px',
    marginBottom: '10px',
    marginTop: 0,
  },
  inlineLabel: {
    display: 'inline-block',
    width: 'auto',
    paddingTop: '0',
  },
  labelTitle: {
    margin: '0'
  },
  textInput: {
    input: {background: '#fff'}
  }
}
